import { useEffect, useState } from 'react';
import { AxiosResponse, AxiosError } from 'axios';

import { useAuth } from '@/hooks/useAuth';
import { api, resetToken } from '@/lib/api';
import Layout from '@/pages/Layout';

interface DebugResponse {
  error?: string;
}

function DebugPage() {
  const [data, setData] = useState<DebugResponse | null>(null)
  const { user } = useAuth()

  useEffect(() => {
    api.get<DebugResponse>('/debug').then((res: AxiosResponse<DebugResponse>) => {
      setData(res.data)
    }).catch((error: AxiosError) => {
      if (error.response && error.response.status === 401) {
        resetToken()
        api.get<DebugResponse>('/debug').then((res: AxiosResponse<DebugResponse>) => {
          setData(res.data)
        }).catch((retryError: AxiosError) => {
          if (retryError.response && retryError.response.status === 401) {
            setData({ error: 'Unauthorized access on retry' });
          }
        });
      }
    });
  }, [])

  return (
    <Layout>
      <div className="p-4 text-red-500">
        <pre>{JSON.stringify(user, null, 2)}</pre>
        <pre>{JSON.stringify(data, null, 2)}</pre>
        <pre>{JSON.stringify(import.meta.env, null, 2)}</pre>
      </div>
    </Layout>
  )
}

export default DebugPage
